import { Toast, ToastMessage } from "primereact/toast";
import { useCallback, useContext, useRef } from "react";

import { ToastContext } from "../../context/ToastContext";

/** "1 claim" / "1,234 claims". */
export const claimCount = (count: number): string =>
  `${count.toLocaleString("en-US")} claim${count === 1 ? "" : "s"}`;

/** The message a bulk endpoint's error body carries, or a generic fallback. */
export const bulkErrorDetail = (err: any): string =>
  err?.data?.error || err?.data?.messages?.[0] || "Request failed.";

/**
 * CLE-3035: toasts for the bulk modals. A successful bulk action clears the
 * selection, which unmounts the actions bar and these modals with it — so the
 * success toast goes to the app-wide Toast (ToastContext) when there is one and
 * outlives the bar. The modal's own Toast is the fallback (tests, or a page
 * rendered outside the app shell).
 */
export function useBulkActionToast() {
  const appToast = useContext(ToastContext);
  const localToast = useRef<Toast>(null);
  const show = useCallback(
    (message: ToastMessage) => {
      (appToast?.current ?? localToast.current)?.show(message);
    },
    [appToast]
  );
  return { localToast, show };
}
